module.exports = __webpack_public_path__ + "img/VA.221b173a.png";